import userService from '@/service/userService'
import axios from 'axios'
import MainPresenter from "@/service/MainPresenter"
import appConfig from '@/service/config'
import moment from 'moment'
import un from 'underscore'

const mainPresenter = new MainPresenter();

const ArticlesService = function() {

    function buildParamsSearch(requestData) {
        return {
            "title": requestData.params.title,
            "itemsPage": requestData.pageable.itemsPage,
            "itemsSize": requestData.pageable.itemsSize
        }
    }

    this.searchArticles = function(requestData, onSuccess, onError) {
        const req = axios({
            method: 'get',
            url: mainPresenter.getUrlForParams("/articles/search", buildParamsSearch(requestData)),
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(e => {
            onError(e)
        })
    }

    function buildParamsAdd(requestData) {
        if (requestData.content === "<p><br></p>") {
            requestData.content = ""
        }
        return {
            title: requestData.title,
            content: requestData.content,
            createdDate: moment(requestData.expenseDate).format("YYYY-MM-DD HH:mm:ss"),
            customSortValue: parseInt(requestData.customSortValue)
        }
    }

    this.addArticle = function(requestData, onSuccess, onError) {
        const req = axios({
            method: 'post',
            url: appConfig.baseUrl + '/articles',
            data: buildParamsAdd(requestData),
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(err => {
            const errors = un.map(err.response.data.errors, item => {
                return item.defaultMessage
            })
            onError(errors)
        })
    }

    function buildParamsEdit(requestData) {
        if (requestData.content === "<p><br></p>") {
            requestData.content = ""
        }
        return {
            title: requestData.title,
            content: requestData.content,
            customSortValue: parseInt(requestData.customSortValue)
        }
    }

    this.editArticle = function(requestData, onSuccess, onError) {
        const req = axios({
            method: 'post',
            url: appConfig.baseUrl + '/articles/' + requestData.articleId +"/edit",
            data: buildParamsEdit(requestData),
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(err => {
            const errors = un.map(err.response.data.errors, item => {
                return item.defaultMessage
            })
            onError(errors)
        })
    }

    this.isAdmin = function() {
        return userService.isAdmin()
    }

    this.loadArticle = function(requestData, onSuccess, onError) {
        const req = axios({
            method: 'get',
            url: appConfig.baseUrl + '/articles/' + requestData.articleId,
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(err => {
            const errors = un.map(err.response.data.errors, item => {
                return item.defaultMessage
            })
            onError(errors)
        })
    }

    this.addComment = function(requestData, onSuccess, onError) {
        const commentForm = {
            content: requestData.content,
            articleId: requestData.articleId,
            createDate: moment().format("YYYY-MM-DD HH:mm:ss")
        }
        const req = axios({
            method: 'post',
            url: appConfig.baseUrl + '/articles/addComment',
            data: commentForm,
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(err => {
            const errors = un.map(err.response.data.errors, item => {
                return item.defaultMessage
            })
            onError(errors)
        })
    }

    return {
        "searchArticles": this.searchArticles,
        "addArticle": this.addArticle,
        "isAdmin": this.isAdmin,
        "loadArticle": this.loadArticle,
        "editArticle": this.editArticle,
        "addComment": this.addComment
    }
}

export default ArticlesService;


// WEBPACK FOOTER //
// ./src/components/articles/ArticlesService.js